
export const popular = [
  {
    name: `tie-dye`,
    title: `Tie Dye`,
    description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam Loret, consectetuer adipiscing elit, sed diam`,
    image: require('@/assets/chapters/ch3/terms/tie-dye.jpg')
  },
  {
    name: `headbands`,
    title: `Headbands`,
    description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam Loret, consectetuer adipiscing elit, sed diam`,
    image: require('@/assets/chapters/ch3/terms/headbands.jpg')
  },
  {
    name: `trench`,
    title: `Trench`,
    description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam Loret, consectetuer adipiscing elit, sed diam`,
    image: require('@/assets/chapters/ch3/terms/trench.jpg')
  },
  {
    name: `feathers`,
    title: `Feathers`,
    description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam Loret, consectetuer adipiscing elit, sed diam`,
    image: require('@/assets/chapters/ch3/terms/feathers.jpg')
  },
  {
    name: `pearl`,
    title: `Pearl`,
    description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam Loret, consectetuer adipiscing elit, sed diam`,
    image: require('@/assets/chapters/ch3/terms/pearl.jpg')
  }
]

export const declining = [
  {
    name: `velvet`,
    title: `Velvet`,
    description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam Loret, consectetuer adipiscing elit, sed diam`,
    image: require('@/assets/chapters/ch3/terms/velvet.jpg')
  },
  {
    name: `sequins`,
    title: `Sequins`,
    description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam Loret, consectetuer adipiscing elit, sed diam`,
    image: require('@/assets/chapters/ch3/terms/sequins.jpg')
  },
  {
    name: `leopard`,
    title: `Leopard`,
    description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam Loret, consectetuer adipiscing elit, sed diam`,
    image: require('@/assets/chapters/ch3/terms/leopard.jpg')
  },
  {
    name: `bustier`,
    title: `Bustier`,
    image: require('@/assets/chapters/ch3/terms/bustier.jpg')
  },
  {
    name: `corset`,
    title: `Corset`,
    description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam Loret, consectetuer adipiscing elit, sed diam`,
    image: require('@/assets/chapters/ch3/terms/corset.jpg')
  }
]

export default {
  popular
}
